import { IViolationResult } from "@vmosolutions/oc-interfaces";
import { Camera } from "../../../SharedGL/Camera";
import { CrewScheduleErrorsGL } from "./CrewScheduleErrorsGL";

const qualificationColor = [1.0, 1.0, 0.0, 1.0];
export class CrewQualificationsGL extends CrewScheduleErrorsGL {
  private qualificationData: IViolationResult[] = [];
  public createdAt = 0;
  /**
   * getQualificationData - the cached qualification data
   */
  public getQualificationData = (): IViolationResult[] => this.qualificationData;

  /**
   * @param dayStartMs - start of day in ms
   * @param dayEndMs - end of day in ms
   * @returns true if any qual violation touches the day
   */
  public hasOnDay(dayStartMs: number, dayEndMs: number): boolean {
    return this.qualificationData.some((v) => v.period.end >= dayStartMs && v.period.start <= dayEndMs);
  }

  /**
   * updateQualificationBuffers - Update the WebGL buffers for the thin top strip
   * @param gl - The WebGL rendering context
   * @param qualifications - Array of qualification violations to be rendered
   * @param rowHeight - the row height of the crew member to draw day violations
   */
  public updateQualificationBuffers(
    gl: WebGLRenderingContext,
    qualifications: IViolationResult[],
    rowHeight: number,
    createdAt: number
  ): void {
    this.createdAt = createdAt ?? 0;

    this.qualificationData = (qualifications ?? []).filter(
      (v) => v && v.status === "fail" && !v.noShow && v.period && v.period.start != null && v.period.end != null
    );

    // super.updateBuffers builds the 6px top strip vertex data
    super.updateBuffers(gl, this.qualificationData, rowHeight, qualificationColor);
  }

  // Draw only the top strip for qualifications (the vertical per-day overlay is drawn via PerDayViolationOverlayGL).
  public draw(gl: WebGLRenderingContext, camera: Camera, yStart: number): void {
    this.drawTopStrip(gl, camera, yStart);
  }
}
